// extracted by mini-css-extract-plugin
module.exports = {"colorbar":"Colorbar_colorbar__10F69"};